import React, {useState, useEffect, FormEvent} from 'react'
import { useInventoryStore } from '../../../state/useInventoryStore'
import { editVariationService } from '../../../backend-services/inventory';
import { v4 as uuidv4 } from 'uuid';
import { InputComponent } from '../../core/Forms';
import * as UI from '../../common'
import { AddSquareIcon } from '../../../assets/icons';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { SidebarDrawer } from '../../common';
import LeftNotificationPopup from '../../core/NotificationPopup/LeftNotificationPopup';
import ProcessSuccessful from '../../../assets/icons/ProcessSuccessful';


interface editVariationPromptProps {
    item:any;
}
const EditVariationForm = ( {item}: editVariationPromptProps) => {
    const [formData, setFormData] = useState({variationName: item.variantName})

    const [variationInputTypes, setVariationInputTypes] = useState<{id: number, placeholder: string, value: string}[]>([])

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [showSuccessfulModal, setShowSuccessfulModal] = React.useState(false);

    const {fetchVariation } = useInventoryStore((state) => ({
      fetchVariation: state.fetchVariation
    }));

    const navigate = useNavigate()

    const handleSubmit = async ( e: React.FormEvent ) => {
      setIsLoading(true) 
      e.preventDefault()
      try {
        const variationTypesArray = variationInputTypes.map((type) => type.value);
        const data = {
          variantName: formData.variationName,
          types: variationTypesArray
        }
        const res = await editVariationService(item.id, data)
        fetchVariation()
        console.log(res)
        if(res){
          toast.success("variation edited successfully")
          
        }
      } catch ( error:any ) {
        toast.error(error.message)
        throw new Error(error.message)
      }
       finally{
        setIsLoading(false)
        setShowSuccessfulModal(true)
        
       }  
    }
    
    const handleOnChange = ( e: React.ChangeEvent<HTMLInputElement> ) => {
        e.preventDefault()
        const {name, value} = e.target
        setFormData({...formData, [name]: value})
    }

    const handleInputChange = (index:any, newValue:any) => {
      const updatedVariationInputTypes = [...variationInputTypes];
     
     console.log(index)
     console.log(updatedVariationInputTypes[index])
      updatedVariationInputTypes[index] = { ...updatedVariationInputTypes[index], value: newValue };
      setVariationInputTypes(updatedVariationInputTypes);
    };

    const handleAddVariationType = () => {
      const newVariationInput = {
        id: parseInt(uuidv4()),
        placeholder: "Type",
        value: ""
      }
      setVariationInputTypes([...variationInputTypes, newVariationInput ])
     console.log(variationInputTypes)
     const variationTypesArray = variationInputTypes.map((type) => type.value);
     console.log(variationTypesArray)
    }

  return (
    <div>
       <form onSubmit={handleSubmit}>
        <div className="flex flex-col items-center">  

     <div className='flex flex-col items-center gap-[16px] md:gap-[14px] mb-[] md:mb-[16px]'>

      <div className='flex flex-col'>
            <label htmlFor="first-name" className="text-[1rem] text-[#666666] font-normal">
                    Variation Name
            </label>
            <div className="max-w-[350px] md:min-w-[434px]">
                    <InputComponent
                      name="variationName"
                      value={formData.variationName}
                      className="border bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal w-[280px] max-w-[350px] md:min-w-[434px] h-[48px] rounded"
                      type="text"
                      placeholder="Size"
                      handleChange={handleOnChange}
                    />
              </div>
          </div>

   {variationInputTypes.map((type:any, index:any) => {
    return (
      <div key={index} className='flex flex-col'>
     <label htmlFor="variation-type" className="text-[1rem] text-[#666666] font-normal">
             Variation Type
     </label>
     <div className="max-w-[350px] md:min-w-[434px]">
                <InputComponent
                      name="variationType"
                      className="border bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px] w-[280px] rounded max-w-[350px] md:min-w-[434px]"
                      type="text"
                      placeholder="Large"
                      value={type.value}
                      handleChange={(e) => handleInputChange(index, e.target.value)}
                    />
       </div>
   </div>
    )
     
})}
    
           <div className='w-full justify-start'>
            <button type='button' onClick={handleAddVariationType} className='flex gap-4 items-center'>
               <p className='text-[#044E97] text-[16px]'>
                Add Variation Type
              </p> 
              <AddSquareIcon/>
              </button>
            </div>        
       </div>

            <div className="xl:w-[300px] md:w-[300px] mt-[0em]"/>
            <div className='flex justify-center items-center'>
              <div className="xl:w-[300px] md:w-[300px] w-[215px] lg:w-[215px] flex justify-center xl:mt-[1em]">
              <UI.Button  variant='secondary' type="submit" text="Save Changes" isLoading={isLoading} />
            </div>
            </div>
            

          </div>
          </form>
          {showSuccessfulModal && (
        <>
         <SidebarDrawer 
          title={'Variation Edited'} 
          show={true} 
          position={'left'} 
          onClose={() => setShowSuccessfulModal(false)}>
          <LeftNotificationPopup 
          title={''}
         icon={<ProcessSuccessful/>}
         onClose={() => setShowSuccessfulModal(false)}
          />
       </SidebarDrawer>
         </>
        )}
    </div>
  )
}

export default EditVariationForm